module.exports = __webpack_public_path__ + "static/media/thumbnail.878f4de9.jpg";